import React from "react";
import styled from "styled-components";
import Theme from "../../Theme/Theme";
import { toast } from "react-toastify";

export class CustomAlert {
  static success(title, text = "") {
    toast.success(
      <NotificationModal
        type={"success"}
        title={title}
        text={text}
      ></NotificationModal>
    );
  }

  static info(title, text = "") {
    toast.info(
      <NotificationModal
        type={"info"}
        title={title}
        text={text}
      ></NotificationModal>
    );
  }

  static error(title, text = "") {
    toast.error(
      <NotificationModal
        type={"error"}
        title={title}
        text={text}
      ></NotificationModal>
    );
  }

  static warning(title, text = "") {
    toast.warning(
      <NotificationModal
        type={"warning"}
        title={title}
        text={text}
      ></NotificationModal>
    );
  }
}

function NotificationModal({ type, title, text }) {
  return (
    <NotificationBox type={type} haveText={text}>
      <TitleContainer>
        <TitleIconContainer type={type}>
          <TitleIconimg
            src={
              type === "success"
                ? "/Assets/Images/CheckIcon.svg"
                : type === "info"
                ? "/Assets/Images/InfoIcon.svg"
                : type === "error"
                ? "/Assets/Images/ErrIcon.svg"
                : "/Assets/Images/InfoIcon.svg"
            }
          ></TitleIconimg>
        </TitleIconContainer>
        <TitleText type={type}>{title}</TitleText>
      </TitleContainer>
      {text !== "" ? (
        <DiscribeContainer>
          <DiscribeText>{text}</DiscribeText>
        </DiscribeContainer>
      ) : null}
    </NotificationBox>
  );
}

const NotificationBox = styled.div`
  width: 350px;
  height: ${(props) => (props.haveText !== "" ? "100px" : "60px")};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  box-sizing: border-box;
`;

const TitleContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
`;

const TitleIconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: 5px;
  border-radius: ${Theme.borderRadius};
  background-color: ${(props) =>
    props.type === "success"
      ? "#BDEECF"
      : props.type === "info"
      ? "#C4DAFC"
      : props.type === "warn"
      ? "#C4DAFC"
      : "#FAC7C7"};
`;

const TitleIconimg = styled.img`
  width: 30px;
  height: 30px;
  object-fit: contain;
`;

const TitleText = styled.p`
  width: 50%;
  height: 80%;
  margin-inline: 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontInfoWeight};
  color: ${(props) =>
    props.type === "success"
      ? "#147638"
      : props.type === "info"
      ? "#3575DD"
      : props.type === "warn"
      ? "#3575DD"
      : "#D73D3D"};
  font-family: "IranSans";
`;

const DiscribeContainer = styled.div`
  box-sizing: border-box;
  width: 80%;
  height: 70px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
  margin-left: 20px;
`;

const DiscribeText = styled.p`
  font-size: ${Theme.fontSize};
  font-weight: ${Theme.fontWeight};
  text-align: justify;
  text-overflow: ellipsis;
  line-height: 20px;
  margin-right: 10px;
  font-family: "IranSans" !important;
`;
